var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": 60,
        "min-height": _vm.modalMinHeight,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("div", { staticClass: "model-content" }, [
        _c(
          "div",
          {
            staticClass: "modal-card",
            style: { minHeight: _vm.modalMinHeight + "vh" },
          },
          [
            _c("header", { staticClass: "modal-card-head" }, [
              _c(
                "p",
                { staticClass: "modal-card-title" },
                [_vm._t("text-title")],
                2
              ),
            ]),
            _c(
              "section",
              { ref: "modalBody", staticClass: "modal-card-body" },
              [
                _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label is-required-label" }, [
                        _vm._v("Quote Template Name"),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.templateName,
                            expression: "templateName",
                          },
                        ],
                        class: [
                          "input is-uppercase",
                          {
                            "is-danger":
                              _vm.$v.templateName.$dirty &&
                              (!_vm.$v.templateName.required ||
                                !_vm.$v.templateName.unique) &&
                              _vm.templateName,
                          },
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "Template Name",
                          maxlength: "30",
                        },
                        domProps: { value: _vm.templateName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.templateName = $event.target.value
                          },
                        },
                      }),
                      _c("div", { staticClass: "help is-secondary" }, [
                        _vm._v(" " + _vm._s(_vm.templateName.length) + "/30 "),
                      ]),
                      _vm.$v.templateName.$dirty &&
                      !_vm.$v.templateName.required
                        ? _c("span", { staticClass: "help is-danger ml-1" }, [
                            _vm._v("Name Required"),
                          ])
                        : _vm._e(),
                      _vm.$v.templateName.$dirty &&
                      !_vm.$v.templateName.unique &&
                      _vm.templateName
                        ? _c("span", { staticClass: "help is-danger ml-1" }, [
                            _vm._v("Name has been taken."),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", { staticClass: "column is-two-fifths" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Add Tag"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "control",
                          staticStyle: { position: "relative" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "dropdown",
                              class: { "is-active": _vm.tagDropdownActive },
                              staticStyle: { width: "100%" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "dropdown-trigger",
                                  staticStyle: { width: "100%" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "input tag-input-fake",
                                      on: { click: _vm.toggleDropdown },
                                    },
                                    [
                                      _vm.selectedTags.length
                                        ? _vm._l(
                                            _vm.selectedTags,
                                            function (tag) {
                                              return _c(
                                                "span",
                                                {
                                                  key: tag.tagID,
                                                  staticClass: "tag-short mr-1",
                                                  style: {
                                                    backgroundColor:
                                                      tag.colorHex,
                                                    color: _vm.getTextColor(
                                                      tag.colorHex
                                                    ),
                                                    marginBottom: "2px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(tag.shortTag) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          )
                                        : _vm._e(),
                                      !_vm.selectedTags.length
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#b5b5b5" },
                                            },
                                            [_vm._v("Add tags")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon is-right",
                                          staticStyle: {
                                            "pointer-events": "none",
                                            position: "absolute",
                                            right: "10px",
                                            top: "10px",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-menu-down",
                                          }),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                              _c("TagsDropdownMenu", {
                                attrs: {
                                  tags: _vm.tags,
                                  "selected-tags": _vm.selectedTagIDs,
                                  "is-visible": _vm.tagDropdownActive,
                                },
                                on: {
                                  "toggle-tag": _vm.toggleTag,
                                  "clear-all-tags": _vm.clearAllTags,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label is-required-label" }, [
                    _vm._v("Template Type"),
                  ]),
                  _c("div", { staticClass: "select is-fullwidth" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.quoteType,
                            expression: "quoteType",
                          },
                        ],
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.quoteType = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.availableQuoteTypes, function (label, key) {
                        return _c(
                          "option",
                          { key: key, domProps: { value: key } },
                          [_vm._v(_vm._s(label))]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "footer",
              {
                staticClass: "modal-card-foot",
                style: `justify-content: flex-${_vm.buttonLocation}`,
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    on: { click: _vm.update },
                  },
                  [_vm._v("Update")]
                ),
                _c(
                  "button",
                  { staticClass: "button", on: { click: _vm.close } },
                  [_vm._v("Close")]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }